import React from 'react';
import LateralMenu from '../LateralMenu';
import { faCar, faClipboardList, faUser } from '@fortawesome/free-solid-svg-icons';

import { translate } from '../../services/translate';
import logo from '../../../assets/logo_dashboard.png';
import collapsedLogo from '../../../assets/icon_dashboard.png';
import { faCameraCctv } from '@fortawesome/pro-solid-svg-icons';
import { faCarBus } from '@fortawesome/pro-regular-svg-icons';

export default function DashboardLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu }: LateralMenuProps) {

    const items = [];

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dashboard_module_access
        || authenticatedUser?.permissions.dashboard_see_occurrence
    ) {
        items.push({
            icon: faClipboardList,
            text: translate('occurrences'),
            action: () => navigation.navigate('Dashboard', { screen: 'DashboardOccurrences' }),
            selected: selectedMenu == 'occurrences'
        });
    }

    if(authenticatedUser?.permissions.dashboard_module_access
        || authenticatedUser?.permissions.dashboard_manage_monitoring_plates_groups
        || authenticatedUser?.permissions.dashboard_manage_monitoring_plates
        || authenticatedUser?.permissions.dashboard_see_monitoring_plates
    ) {
        items.push({
            icon: faCarBus,
            text: translate('plateMonitoring'),
            action: () => navigation.navigate('Dashboard', { screen: 'DashboardPlateMonitoring' }),
            selected: selectedMenu == 'plate-monitoring'
        });
    }

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dashboard_module_access
        || authenticatedUser?.permissions.dashboard_see_cameras
    ) {
        items.push({
            icon: faCameraCctv,
            text: translate('cameras'),
            action: () => navigation.navigate('Dashboard', { screen: 'DashboardCameras' }),
            selected: selectedMenu == 'cameras'
        });
    }

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dashboard_module_access
        || authenticatedUser?.permissions.dashboard_see_agents
        || authenticatedUser?.permissions.dashboard_see_agents_acting_bodies
        || authenticatedUser?.permissions.dashboard_see_agents_acting_body_units
    ) {
        items.push({
            icon: faUser,
            text: translate('agents'),
            action: () => navigation.navigate('Dashboard', { screen: 'DashboardAgents' }),
            selected: selectedMenu == 'agents'
        });
    }

    if (authenticatedUser?.isAdmin
        || authenticatedUser?.permissions.dashboard_see_vehicles
        || authenticatedUser?.permissions.dashboard_see_vehicles_acting_bodies
        || authenticatedUser?.permissions.dashboard_see_vehicles_acting_body_units
    ) {
        items.push({
            icon: faCar,
            text: translate('vehicles'),
            action: () => navigation.navigate('Dashboard', { screen: 'DashboardVehicles' }),
            selected: selectedMenu == 'vehicles'
        });
    }

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={items}
        />
    );
}
